const uz = {
  home: "Bosh sahifa",
  signals: "Signallar",
  analysis: "Tahlil",
  analytics: "Analitika",
  profile: "Profil",
  aiAssistant: "AI yordamchi",
  greeting: "Xayrli kun",
  marketOpen: "Bozor tahlilga tayyor",
  proPlan: "PRO reja",
  demoData: "Demo ma’lumot",
  todaySignals: "Bugungi signallar",
  winRate: "G‘alaba darajasi",
  totalR: "Jami R",
  activeSignals: "Faol signallar",
  watchlist: "Bozorlar",
  activeSetup: "So‘nggi savdo holati",
  viewSignal: "Signalni ko‘rish",
  setupQuality: "Holat sifati",
  entry: "Kirish",
  stopLoss: "Stop Loss",
  targets: "Maqsadlar",
  all: "Barchasi",
  active: "Faol",
  history: "Tarix",
  buy: "Sotib olish",
  sell: "Sotish",
  signalDetails: "Signal tafsilotlari",
  tradePlan: "Savdo rejasi",
  reasoning: "Tahlil asoslari",
  timeline: "Natijalar tarixi",
  liveChart: "Jonli grafik",
  chartProvider: "Haqiqiy OHLC bozor grafigi",
  performance: "Natijalar",
  profitFactor: "Profit factor",
  expectancy: "Kutilma",
  drawdown: "Maks. pasayish",
  period7: "7K",
  period30: "30K",
  period3m: "3O",
  periodAll: "Barchasi",
  equityCurve: "R kapital egri chizig‘i",
  calendar: "Iqtisodiy kalendar",
  highImpact: "Yuqori ta’sir",
  previous: "Oldingi",
  forecast: "Prognoz",
  actual: "Fakt",
  subscription: "Obuna",
  expires: "Amal qilish muddati",
  language: "Til",
  support: "Yordam",
  legal: "Huquqiy hujjatlar",
  upgrade: "Rejani tanlash",
  realtime: "Jonli bozor tahlili",
  delayed30: "Signallar 30 daqiqa kechikadi",
  fullAnalytics: "To‘liq analitika va tarix",
  proAssets: "XAUUSD va Forex juftliklari",
  payment: "Obuna uchun to‘lov",
  card: "To‘lov kartasi",
  uploadReceipt: "Chekni yuklash",
  payerName: "To‘lovchi F.I.Sh.",
  amount: "To‘lov miqdori",
  submitReview: "Tekshiruvga yuborish",
  paymentPending: "Admin tekshiruvi kutilmoqda",
  confidenceNote:
    "Bu g‘alaba ehtimoli emas, savdo holati sifati ko‘rsatkichidir.",
  noSignals: "Tanlangan filtr bo‘yicha signal yo‘q.",
  viewCalendar: "Kalendar",
  chooseStrategies: "Strategiyalarni tanlang",
  runAnalysis: "Jonli tahlilni boshlash",
  noSetup: "Hozircha sifatli savdo holati topilmadi",
  remaining: "Qolgan tahlillar",
  skipContent: "Asosiy kontentga o‘tish",
  primaryNavigation: "Asosiy navigatsiya",
} as const;
const ru: Record<keyof typeof uz, string> = {
  home: "Главная",
  signals: "Сигналы",
  analysis: "Анализ",
  analytics: "Аналитика",
  profile: "Профиль",
  aiAssistant: "AI помощник",
  greeting: "Добрый день",
  marketOpen: "Рынок готов к анализу",
  proPlan: "Тариф PRO",
  demoData: "Демо-данные",
  todaySignals: "Сигналов сегодня",
  winRate: "Винрейт",
  totalR: "Итого R",
  activeSignals: "Активные сигналы",
  watchlist: "Рынки",
  activeSetup: "Последний сетап",
  viewSignal: "Открыть сигнал",
  setupQuality: "Качество сетапа",
  entry: "Вход",
  stopLoss: "Стоп-лосс",
  targets: "Цели",
  all: "Все",
  active: "Активные",
  history: "История",
  buy: "Покупка",
  sell: "Продажа",
  signalDetails: "Детали сигнала",
  tradePlan: "Торговый план",
  reasoning: "Обоснование",
  timeline: "Хронология результата",
  liveChart: "Живой график",
  chartProvider: "Реальный рыночный OHLC-график",
  performance: "Результаты",
  profitFactor: "Профит-фактор",
  expectancy: "Ожидание",
  drawdown: "Макс. просадка",
  period7: "7Д",
  period30: "30Д",
  period3m: "3М",
  periodAll: "Все",
  equityCurve: "Кривая капитала в R",
  calendar: "Экономический календарь",
  highImpact: "Высокое влияние",
  previous: "Предыдущее",
  forecast: "Прогноз",
  actual: "Факт",
  subscription: "Подписка",
  expires: "Действует до",
  language: "Язык",
  support: "Поддержка",
  legal: "Правовые документы",
  upgrade: "Выбрать тариф",
  realtime: "Анализ рынка в реальном времени",
  delayed30: "Задержка сигналов 30 минут",
  fullAnalytics: "Полная аналитика и история",
  proAssets: "XAUUSD и валютные пары",
  payment: "Оплата подписки",
  card: "Карта для оплаты",
  uploadReceipt: "Загрузить чек",
  payerName: "Ф.И.О. плательщика",
  amount: "Сумма оплаты",
  submitReview: "Отправить на проверку",
  paymentPending: "Ожидается проверка администратора",
  confidenceNote: "Это оценка качества сетапа, а не вероятность выигрыша.",
  noSignals: "По выбранному фильтру сигналов нет.",
  viewCalendar: "Календарь",
  chooseStrategies: "Выберите стратегии",
  runAnalysis: "Запустить живой анализ",
  noSetup: "Качественный сетап пока не найден",
  remaining: "Осталось анализов",
  skipContent: "Перейти к основному содержимому",
  primaryNavigation: "Основная навигация",
};
export const messages = { uz, ru };
export type MessageKey = keyof typeof uz;
